<template>
    <v-container v-if="isCreating">
        <v-card>
            <h2 class="text-center">Create New Venom Lot {{venomLotID}}</h2>
            <v-progress-linear slot="progress" color="primary" indeterminate v-if="createdLoading"></v-progress-linear>
            <v-row v-else>
                <v-col cols="12" md="6" offset-md="3">
                    <v-form @submit.prevent ref="editForm" v-model="createValid">
                        <v-row >
                            <v-col cols="12">
                                <v-select
                                    :items="species"
                                    item-text="SpeciesFullName"
                                    item-value="SpeciesID"
                                    v-model="newRecord.SpeciesID"
                                    label="Species"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>
                            
                            <v-col cols="12" class="text-center">
                                <v-btn
                                    :disabled="!createValid"
                                    :loading="loadingData"
                                    color="accent"
                                    @click="createRecord()"
                                >
                                    Create
                                </v-btn>
                            </v-col>

                            <v-col cols="12" class="text-center">
                                <v-alert v-if="error" outlined :value="true" color="error" icon="error">
                                    {{error}}
                                </v-alert>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-card>
            <h2 class="text-center">{{venomLot.IsClosed ? "Venom Lot Details" : "Manage Venom Lot"}}</h2>
            <v-row >

                <v-col cols="12" md="6" offset-md="3" class="text-center">
                    <v-alert v-if="error" outlined :value="true" color="error" icon="error">
                        {{error}}
                    </v-alert>
                </v-col>

                <v-progress-linear slot="progress" color="primary" indeterminate v-if="loadingData"></v-progress-linear>

                <v-col cols="12" md="9" offset-md="3" v-else>
                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Barcode
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ (venomLot && venomLot.Barcode) ? venomLot.Barcode.toUpperCase() : "" }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Created
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ $moment(venomLot.CreatedTime).format($constants.DATE_FORMAT) }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    By
                                </v-col>
                                <v-col cols="10" class="highlighted-data">
                                    {{ venomLot.CreatedByFullName}} ({{venomLot.CreatedByEmail}})
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4" v-if="venomLot.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Closed
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ $moment(venomLot.ClosedTime).format($constants.DATE_FORMAT) }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col sm="12" md="8" v-if="venomLot.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    By
                                </v-col>
                                <v-col cols="10" class="highlighted-data">
                                    {{ venomLot.ClosedByFullName}} ({{venomLot.ClosedByEmail}})
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Species
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ venomLot.SpeciesFullName }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    Total Weight
                                </v-col>
                                <v-col cols="10" class="highlighted-data">
                                    {{ venomLot.TotalWeight || 0 }}g
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters class="mt-6" v-if="venomLot.IsClosed">

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="6">
                                    Lot Numbers
                                </v-col>
                                <v-col cols="6" class="highlighted-data">
                                    {{ venomLot.QALotNumbers }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    RP-HPLC STD. PROTOCOL ANALYSIS
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ venomLot.QAProtocolAnalysis }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters v-if="venomLot.IsClosed">

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="6">
                                    Color / Appearance
                                </v-col>
                                <v-col cols="6" class="highlighted-data">
                                    {{ venomLot.QAAppearance }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    Result
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ venomLot.QAResult }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters v-if="venomLot.IsClosed">

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="6">
                                    Quality
                                </v-col>
                                <v-col cols="6" class="highlighted-data">
                                    {{ venomLot.QAQuality }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    Comments
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ venomLot.QAComments }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col cols="12" md="8" class="text-center">
                            <v-btn
                                v-if="!venomLot.IsClosed"
                                color="success"
                                @click="displayQADialog = true"
                            >
                                QA
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="printBarcode()"
                                class="ml-2"
                            >
                                Print Barcode
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="exportLot"
                                :disabled="exporting" 
                                :loading="exporting"
                                class="ml-2"
                            >
                                Export
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="print"
                                class="ml-2"
                            >
                                Print
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        
        <v-card v-if="!loadingData && !venomLot.IsClosed" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Add Species Batch Pools</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <VenomLotAvailableSpeciesBatchPools
                                    :venomLotID="venomLot.VenomLotID"
                                    :speciesID="venomLot.SpeciesID"
                                    @recordsAdded="monthlyPoolRecordsAdded"
                                    @showCloseDialog="showCloseDialog"
                                >
                                </VenomLotAvailableSpeciesBatchPools>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingData" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Entered Records</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-data-table
                                    :headers="enteredRecordsHeaders"
                                    :items="venomLot.SpeciesBatchPools"
                                    :loading="loadingData || loadingEnteredRecords"
                                    :items-per-page.sync="enteredRecordsPagination.rowsPerPage"
                                    must-sort>
                                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                    <template  v-slot:item="props">
                                        <tr :data-id="props.item.SpeciesBatchPoolID">
                                            <td>{{props.item.Barcode}}</td>
                                            <td>{{props.item.SpeciesFullName}}</td>
                                            <td>{{props.item.TotalWeightAddedToThisVenomLot || 0}}g</td>
                                            <td>
                                                <v-btn
                                                    color="info"
                                                    block
                                                    @click="viewSpeciesBatchPool(props.item.SpeciesBatchPoolID)"
                                                >
                                                    View Species Batch Pool
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="!loadingEnteredRecords" slot="no-data">
                                        <v-alert outlined :value="true" type="info">
                                            No Species Batch Pools added
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        
                        <DashboardPieGraph 
                            :height="graphHeight" 
                            :data="pieGraphData" 
                            :options="pieGraphOptions"
                        >
                        </DashboardPieGraph>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingData" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Venom Analysis</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <VenomAnalysis
                            :venomLotID="venomLotIDInteger">
                        </VenomAnalysis>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <VenomLotQADialog
            :venomLotID="venomLot.VenomLotID"
            :display="displayQADialog"
            @closeDialog="displayQADialog = false"
            @dataUpdated="loadData"
        >
        </VenomLotQADialog>
        <SpeciesBatchPoolCloseDialog ref="closeDialog"></SpeciesBatchPoolCloseDialog>
    </v-container>
</template>

<script>

import VenomAnalysis from '../venomanalysis/VenomAnalysis';
import VenomLotQADialog from "./VenomLotQADialog";
import DashboardPieGraph from "@/components/dashboard/DashboardPieGraph";
import SpeciesBatchPoolCloseDialog from "@/components/venompooling/SpeciesBatchPoolCloseDialog";
import VenomLotAvailableSpeciesBatchPools from "@/components/venompooling/VenomLotAvailableSpeciesBatchPools";
import util from '@/helpers/util';
import validationRules from "../../helpers/validationrules";
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import exports from "@/services/export";

import moment from 'moment';

export default {
    components: {
        VenomAnalysis,
        VenomLotQADialog,
        DashboardPieGraph,
        SpeciesBatchPoolCloseDialog,
        VenomLotAvailableSpeciesBatchPools
    },
    props: {
        
    },
    data() {
        return {
            rules: validationRules.rules,

            newRecord: {},
            createValid: false,
            createError: null,

            loadingData: false,
            venomLot: {},
            loadingEnteredRecords: false,
            loadError: null,

            displayQADialog: false,
            closeEmptyPools: true,
            enteredRecordsHeaders: [
                {
                    text: "Barcode",
                    value: "Barcode"
                },
                {
                    text: "Species",
                    value: "SpeciesFullName"
                },
                {
                    text: "Weight",
                    value: "TotalWeight"
                },
                {
                    text: "",
                    value: ""
                }
            ],
            enteredRecordsPagination: {
                rowsPerPage: 10,
            },

            graphHeight: 150,
            pieGraphData: {
                labels: [],
                datasets: [
                    {
                        label: "Location",
                        data: [],
                        backgroundColor: [
                            '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
                            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
                            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
                            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
                            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
                            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
                        ]
                    }
                ]
            },
            pieGraphOptions: {},

            exporting: false
        }
    },
    computed: {
        venomLotID() {
            return this.$route.params.venomLotID;
        },
        error() {
            return this.createError || this.loadError;
        },
        isCreating() {
            return !(this.venomLotID && this.venomLotID > 0);
        },
        createdLoading() {
            return this.$store.state.speciesStore.loading
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsVenomSupplier).sort(util.sortByField("SupplierName"));
        },
        pendingFileValid() {
            return this.pendingFileName && this.pendingFileName != "" && this.pendingFile && this.pendingFile != null;
        },
        venomLotIDInteger() {
            return parseInt(this.venomLotID)
        }
    },
    methods: {
        async exportLot() {
            this.exporting = true;

            await exports.exportVenomLot(this.venomLotID);
            
            this.exporting = false;
        },
        print() {
            let routeData = this.$router.resolve({name: 'printvenomlot', params: { venomLotID: this.venomLotID }});
            window.open(routeData.href, '_blank');
        },
        monthlyPoolRecordsAdded() {
            this.loadData(true);
        },
        async createRecord() {
            this.loadingData = true;

            try {
                // we need to send the date according to the user to the server (this is used when generating the unique barcodes for venom lots)
                this.newRecord.VenomLotDate = moment().format(constants.MYSQL_DATE_FORMAT);

                const savedRecordID = await VenomPoolingAPI.saveVenomLot(this.newRecord);

                this.$router.replace({
                    name: "venomLot",
                    params: {
                        venomLotID: savedRecordID
                    }
                });
            }
            catch (e) {
                // only turn off the loading indicator if there was an error
                // if there was no error then we will proceed to load the new record, so the loading indicator should remain on
                this.createError = e;

                // eslint-disable-next-line no-console
                console.log(e);

                this.loadingData = false;
            }
            finally {

            }
        },
        async loadData(alternateLoadingIndicator = false) {
            this.displayQADialog = false;

            if (alternateLoadingIndicator) {
                this.loadingEnteredRecords = true;
            }
            else {
                this.loadingData = true;
            }
            
            try {
                this.venomLot = await VenomPoolingAPI.getVenomLots({ venomLotID: this.venomLotID });

                // put data in correct place for graphs
                const newLabels = [];
                const newData = [];

                const graphData = this.venomLot.GeographicalLocations;
                if(graphData){
                    for (const datum of graphData) {
                        newLabels.push(datum.GeographicalLocationName);
                        newData.push(datum.ContributionValue);
                    }
                }
                this.pieGraphData.labels = newLabels;
                this.pieGraphData.datasets[0].data = newData;
            }
            catch (e) {
                this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            finally {
                this.loadingData = false;
                this.loadingEnteredRecords = false;
            }
        },
        printBarcode() {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: this.venomLot.Barcode }});
            window.open(routeData.href, '_blank');
        },
        viewSpeciesBatchPool(speciesBatchPoolID) {
            let routeData = this.$router.resolve({name: 'speciesBatchPool', params: { speciesBatchPoolID: speciesBatchPoolID }});
            window.open(routeData.href, '_blank');
        },
        async saveAnalysis() {
            this.savingVenomAnalysis = true;

            await VenomPoolingAPI.createUpdateMonthlyPool({
                MonthlyPoolID: this.venomLot.MonthlyPoolID,
                AnalysisComments: this.venomLot.AnalysisComments
            });

            this.savingVenomAnalysis = false; 
        },
        showCloseDialog(speciesBatchPoolID){
            this.$refs.closeDialog.showDialog(speciesBatchPoolID);
        }
    },
    watch: {
        $route(to, from) {
            // the route changes as a result of what we do in createRecord() - we navigate to the same route
            // see note under https://router.vuejs.org/guide/essentials/navigation.html#router-push-location-oncomplete-onabort about when the destination is the same as the current route

            this.loadData();
        }
    },
    created() {
        this.$store.dispatch("speciesStore/loadSpecies");
        // this.$store.dispatch("supplierStore/loadSuppliers");

        if (!this.isCreating){
            this.loadData();
        }
    }
}
</script>

<style lang="scss" scoped>
    #app {
        .highlighted-data {
            font-weight: bold;
            margin-top: auto;
            margin-bottom: auto;
        }
    }
</style>